(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('serviceObjectNewAct', {
        templateUrl: 'views/components/views/serviceObjectNewAct/serviceObjectNewAct.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'serviceObjectNewActService', function ($stateParams, stateService, utilityService, modalService, translateService, serviceObjectNewActService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let serviceObjectKeyno = $stateParams.serviceobject_keyno;

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                setting: {},
                itemsListNewActs: [],
                lockedSave: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE CALLS

            async function loadSetting() {
                vm.model.setting = (await serviceObjectNewActService.getSettings({ serviceobject_keyno: serviceObjectKeyno }))[0];
            }
            
            async function loadNewActs() {
                if (utilityService.validateParmsValue(vm.model.setting.start_date) !== true) return;
                
                return vm.model.itemsListNewActs = await serviceObjectNewActService.listNewActs(vm.model.setting);
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region TOGGLE FUNCTIONS
            
            vm.toggleChosen = function (item) {
                item = item?.item ? item.item : item;
                
                if (item.item_id === '0' || item.item_id === '-1') return;
                
                if (item.item_is_selected === '0') {
                    item.item_is_selected = '1';
                } else if (item.item_is_selected === '1') {
                    item.item_is_selected = '0';
                }
            };

            vm.setMarkedAs = function () {
                vm.model.lockedSave = true;
                let selectedItems = [];

                vm.model.itemsListNewActs.forEach((item) => {
    				if (item.item_id === '0' || item.item_id === '-1') return;
    				if (item.item_is_selected === '0') return;
    
                    selectedItems.push({
                        serviceobjecttypeint_keyno: item.item_id,
                        nextdate: item.nextdate
                    });
                });
                
                serviceObjectNewActService.createObj({
                    serviceobject_keyno: vm.model.setting.serviceobject_keyno,
                    records: selectedItems
                }).then(function (response) {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.lockedSave = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedSave = false;
                        stateService.back();
                    }
                });
    		}

            // #endregion TOGGLE FUNCTIONS

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'start_date':
                        if (utilityService.validateWatchValue(value, vm.model.setting.start_date) !== true) return;

                        vm.model.setting.start_date = value;

                        if (utilityService.validateParmsValue(vm.model.setting.start_date) !== true) return;

                        loadNewActs();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                await loadSetting();
                loadNewActs();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
